var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBagOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 7.33333V4.66667C10.6667 3.95942 10.3858 3.28115 9.8857 2.78105C9.3856 2.28095 8.70733 2 8.00008 2C7.29284 2 6.61456 2.28095 6.11446 2.78105C5.61437 3.28115 5.33341 3.95942 5.33341 4.66667V7.33333M3.33341 6H12.6667L13.3334 14H2.66675L3.33341 6Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagOutline);
export default __webpack_public_path__ + "static/media/ShoppingBagOutline.890a4e633b372f0ad705d6c8a300b033.svg";
export { ForwardRef as ReactComponent };